module.exports = __webpack_public_path__ + "static/media/projectImg.0867693e.png";